module.exports = __webpack_public_path__ + "img/pro-zdIcon6.2f4bafe6.png";